/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import { cloneElement } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiScreenReaderOnly = ({
  children,
  showOnFocus
}) => {
  const classes = classNames({
    euiScreenReaderOnly: !showOnFocus,
    'euiScreenReaderOnly--showOnFocus': showOnFocus
  }, children.props.className);
  const props = { ...children.props,
    className: classes
  };
  return cloneElement(children, props);
};
EuiScreenReaderOnly.propTypes = {
  /**
     * ReactElement to render as this component's content
     */
  children: PropTypes.element.isRequired,

  /**
     * For keyboard navigation, force content to display visually upon focus.
     */
  showOnFocus: PropTypes.bool
};

try {
  EuiScreenReaderOnly.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/accessibility/screen_reader_only/screen_reader_only.tsx',
    description: '',
    displayName: 'EuiScreenReaderOnly',
    methods: [],
    props: {
      children: {
        defaultValue: null,
        description: "ReactElement to render as this component's content",
        name: 'children',
        parent: {
          fileName: 'app/src/components/accessibility/screen_reader_only/screen_reader_only.tsx',
          name: 'EuiScreenReaderOnlyProps'
        },
        declarations: [{
          fileName: 'app/src/components/accessibility/screen_reader_only/screen_reader_only.tsx',
          name: 'EuiScreenReaderOnlyProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ReactElement'
        }
      },
      showOnFocus: {
        defaultValue: null,
        description: 'For keyboard navigation, force content to display visually upon focus.',
        name: 'showOnFocus',
        parent: {
          fileName: 'app/src/components/accessibility/screen_reader_only/screen_reader_only.tsx',
          name: 'EuiScreenReaderOnlyProps'
        },
        declarations: [{
          fileName: 'app/src/components/accessibility/screen_reader_only/screen_reader_only.tsx',
          name: 'EuiScreenReaderOnlyProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: ['EuiScreenReaderOnlyProps']
  };
} catch (e) {}